import React from 'react';
import { type IconName, PATH_MAP } from './icon-paths';

type IconProps = {
  name: IconName;
  size?: number;
  fill?: React.CSSProperties['color'];
};

const Icon: React.FC<IconProps> = ({ name, size = 24, fill }) => {
  const paths =
    typeof PATH_MAP[name] === 'string' ? [PATH_MAP[name]] : PATH_MAP[name];
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {paths.map((path, index) => (
        <path key={index} d={path} fill={fill} />
      ))}
    </svg>
  );
};

export default Icon;
